import React from 'react'
import { QueryClient, QueryClientProvider } from 'react-query'

export function retry(failureCount, error) {
  const status = error?.status ?? error?.response?.status
  if (status === 404) {
    return false
  }
  if (failureCount < 2) {
    return true
  }
  return false
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry,
    },
  },
})

export default function QueryClientProviderWrapper({ children }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
